import { gql } from '@apollo/client'

export const GET_TASK_STATUSES = gql`
  query GetTaskStatuses {
    taskStatuses {
      status_id
      status
    }
  }
`

export const GET_TASK_TEMPLATES = gql`
  query GetTaskTemplates {
    taskTemplates {
      task_template_id
      name
      require_execution
      task_info_default
      salary_correction
      timebank_correction
    }
  }
`

export const GET_TASK_TEMPLATE_BLUEPRINTS = gql`
  query GetTaskTemplateBlueprints {
    taskTemplateBlueprints {
      template_id
      name
      tasks {
        task_template_blueprint_id
        task_template_id
        role_id
        room_id
        required_num
      }
    }
  }
`
